import {
  createSelector,
  createSlice,
  type PayloadAction,
} from '@reduxjs/toolkit'

import type { SessionItem } from '../../types/responses/sessions'
import type { RootState } from '../store'

type SessionState = {
  session?: SessionItem
  isLoaded: boolean
}

const initialState: SessionState = {
  isLoaded: false,
}

export const sessionSlice = createSlice({
  name: 'session',
  initialState,
  reducers: {
    setSession: (state, action: PayloadAction<SessionState['session']>) => {
      state.session = action.payload
    },

    setIsLoaded: (state, action: PayloadAction<SessionState['isLoaded']>) => {
      state.isLoaded = action.payload
    },
  },
})

export const selectSessionSlice = (state: RootState) => state.session

export const selectSession = createSelector(
  selectSessionSlice,
  (state) => state.session,
)

export const selectIsSessionLoaded = createSelector(
  selectSessionSlice,
  (session) => session.isLoaded,
)

export const selectIsAuthenticated = createSelector(
  selectSessionSlice,
  (session) => !!session.session,
)

export const selectIsGuest = createSelector(
  selectSessionSlice,
  (session) => !session.session,
)

export const { setSession } = sessionSlice.actions

export const sessionReducer = sessionSlice.reducer
